import { DOCUMENT, inject, Injectable } from '@angular/core';
import { ProductModel} from '@libs/shop/models';
import { ProductTrackingModel, TrackingProductModel } from '@libs/shop/models';
import { getTrackingPagePath } from '../context';
import { TrackingMapperService } from '../mapper';
import { TrackingGoogleService } from '../services';

@Injectable({ providedIn: 'root' })
export class ProductDetailTrackingService {
  private readonly document: Document = inject(DOCUMENT);
  private readonly tracking: TrackingGoogleService = inject(TrackingGoogleService);
  private readonly trackingMapper: TrackingMapperService = inject(TrackingMapperService);

  public trackDetailView(product: ProductModel): void {
    const pathName: string = getTrackingPagePath(this.document);
    const trackingProducts: TrackingProductModel[] = [{ ...product, type: 'product', quantity: 1, position: 0 }];
    const products: ProductTrackingModel[] = this.trackingMapper.mapProductToProductTracking(trackingProducts, pathName);

    this.tracking.trackEvent('detailView', { products });
  }
}
